import { inject, computed } from 'vue';

export default function useLocate() {
  const { locale } = useI18n()
  const getConfigJson = inject('getConfigJson', () => ({}));
  const getCommonConfigJson = inject('getCommonConfigJson', () => ({}));
  const setLangJsonConfigMap = inject('setLangJsonConfigMap');

  const langJson = computed(() => {
    let res={};
    if(getCommonConfigJson && typeof getCommonConfigJson === 'function' ){
      Object.assign(
        res,
        getCommonConfigJson().langJson
      )
    }
    if(getConfigJson && typeof getConfigJson === 'function' ){
      Object.assign(
        res,
        getConfigJson().langJson
      )
    }
    
    return res;
  });
 
  const langCodeProxyMap = {
    "zh-CN":"hans",
    "zh_CN":"hans",
    "zh-Hans":"hans",
    "zh_Hans":"hans",
    "zh-Hans-CN":"hans",
    "zh_Hans_CN":"hans",
    "hans":"hans",
    "zh-TW":"hant",
    "zh_TW":"hant",
    "zh-Hant":"hant",
    "zh_Hant":"hant",
    "zh-HK":"hant",
    "zh_HK":"hant",
    "zh-MO":"hant",
    "zh_MO":"hant",
    "hant":"hant",
    "vi_VN":"vi",
    "vi-VN":"vi",
    "vi":"vi",
    "ja_JP":"ja",
    "ja-JP":"ja",
    "ja":"ja",
    "en":"en",
    "en-US":"en",
    "en_GB":"en",
    "en-GB":"en",
  }
  const nowLocale = computed(() => {
    let res='hans';
    
    if(locale.value&&langCodeProxyMap[locale.value]){
      res=langCodeProxyMap[locale.value];
    }
    return res;
  });

  const getLocaleText = (text) => {
    
    if (process.client&&typeof setLangJsonConfigMap === 'function' && text) {
       
      setLangJsonConfigMap(text);
    }
    return langJson.value[text] && langJson.value[text][nowLocale.value] ? langJson.value[text][nowLocale.value] : text;
  };

  return {
    langJson,
    nowLocale,
    getLocaleText,
  };
}
